import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import PaymentForm from '../../components/basis-theory/payment-form'
import { paymentSessionApi } from '../../lib/api/paymentSession'
import { ErrorDisplay } from '../../components/error-display'
import { LoadingSpinner } from '../../components/loading-spinner'
import { ApiError } from '../../lib/api/types'
import OrderSummary from '../../components/order-summary'

const ErrorDisplayContainer = ({ error }: { error: ApiError | null }) => {
  return (
    <div className="flex justify-center items-center h-screen bg-gray-50">
      <div className="w-full max-w-md p-4">
        <ErrorDisplay error={error} />
      </div>
    </div>
  )
}

export function PaymentsPage() {
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('sessionId')

  const {
    data: paymentSession,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['paymentSession', sessionId],
    queryFn: () => paymentSessionApi.getPaymentSession(sessionId!),
    enabled: !!sessionId,
  })
  if (!searchParams.get('sessionId')) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <div className="w-full max-w-md p-4">No session ID found. Please check the URL.</div>
      </div>
    )
  }

  if (!sessionId) {
    return <ErrorDisplayContainer error={error as ApiError} />
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <LoadingSpinner />
      </div>
    )
  }

  if (isError) {
    return <ErrorDisplayContainer error={error as ApiError} />
  }

  if (!paymentSession) {
    return <ErrorDisplayContainer error={error as ApiError} />
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl w-full">
        <div className="flex justify-center items-center">
          <OrderSummary paymentSession={paymentSession} />
        </div>
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <PaymentForm paymentSession={paymentSession} />
        </div>
      </div>
    </div>
  )
}
